var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "topography-shape js-shape",
    width: "1200px",
    height: "580px",
    viewBox: "0 0 1200 580",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M734.567 34.372c-28.692 61.724-23.266 100.422 16.275 116.094 59.313 23.508 200.347 32.911 259.299 83.906 58.95 50.994 238.697 11.572 269.438-75.95C1310.32 70.9 1365.669-64 1073.808-64c-194.576 0-307.654 32.79-339.24 98.372h-.001z",
    fill: "#FFFA72",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M734.567 34.372c-28.692 61.724-23.266 100.422 16.275 116.094 59.313 23.508 200.347 32.911 259.299 83.906 58.95 50.994 238.697 11.572 269.438-75.95C1310.32 70.9 1365.669-64 1073.808-64c-194.576 0-307.654 32.79-339.24 98.372h-.001z",
    fill: "#FFFA72",
    fillRule: "nonzero",
    transform: "translate(-1800, 60) scale(2.8, 2.8) skewX(30) ",
    style: {
      position: "relative",
      zIndex: 0,
      fill: "rgb(101, 32, 96)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.567 34.372c-28.692 61.724-23.266 100.422 16.275 116.094 59.313 23.508 200.347 32.911 259.299 83.906 58.95 50.994 238.697 11.572 269.438-75.95C1310.32 70.9 1365.669-64 1073.808-64c-194.576 0-307.654 32.79-339.24 98.372h-.001z",
    fill: "#FFFA72",
    fillRule: "nonzero",
    transform: "translate(-1650, 55) scale(2.65, 2.65) skewX(27.5) ",
    style: {
      position: "relative",
      zIndex: 1,
      fill: "rgb(96, 47, 106)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.567 34.372c-28.692 61.724-23.266 100.422 16.275 116.094 59.313 23.508 200.347 32.911 259.299 83.906 58.95 50.994 238.697 11.572 269.438-75.95C1310.32 70.9 1365.669-64 1073.808-64c-194.576 0-307.654 32.79-339.24 98.372h-.001z",
    fill: "#FFFA72",
    fillRule: "nonzero",
    transform: "translate(-1500, 50) scale(2.5, 2.5) skewX(25) ",
    style: {
      position: "relative",
      zIndex: 2,
      fill: "rgb(92, 63, 115)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.567 34.372c-28.692 61.724-23.266 100.422 16.275 116.094 59.313 23.508 200.347 32.911 259.299 83.906 58.95 50.994 238.697 11.572 269.438-75.95C1310.32 70.9 1365.669-64 1073.808-64c-194.576 0-307.654 32.79-339.24 98.372h-.001z",
    fill: "#FFFA72",
    fillRule: "nonzero",
    transform: "translate(-1350, 45) scale(2.3499999999999996, 2.3499999999999996) skewX(22.5) ",
    style: {
      position: "relative",
      zIndex: 3,
      fill: "rgb(87, 79, 124)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.567 34.372c-28.692 61.724-23.266 100.422 16.275 116.094 59.313 23.508 200.347 32.911 259.299 83.906 58.95 50.994 238.697 11.572 269.438-75.95C1310.32 70.9 1365.669-64 1073.808-64c-194.576 0-307.654 32.79-339.24 98.372h-.001z",
    fill: "#FFFA72",
    fillRule: "nonzero",
    transform: "translate(-1200, 40) scale(2.2, 2.2) skewX(20) ",
    style: {
      position: "relative",
      zIndex: 4,
      fill: "rgb(83, 94, 133)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.567 34.372c-28.692 61.724-23.266 100.422 16.275 116.094 59.313 23.508 200.347 32.911 259.299 83.906 58.95 50.994 238.697 11.572 269.438-75.95C1310.32 70.9 1365.669-64 1073.808-64c-194.576 0-307.654 32.79-339.24 98.372h-.001z",
    fill: "#FFFA72",
    fillRule: "nonzero",
    transform: "translate(-1050, 35) scale(2.05, 2.05) skewX(17.5) ",
    style: {
      position: "relative",
      zIndex: 5,
      fill: "rgb(79, 110, 143)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.567 34.372c-28.692 61.724-23.266 100.422 16.275 116.094 59.313 23.508 200.347 32.911 259.299 83.906 58.95 50.994 238.697 11.572 269.438-75.95C1310.32 70.9 1365.669-64 1073.808-64c-194.576 0-307.654 32.79-339.24 98.372h-.001z",
    fill: "#FFFA72",
    fillRule: "nonzero",
    transform: "translate(-900, 30) scale(1.9, 1.9) skewX(15) ",
    style: {
      position: "relative",
      zIndex: 6,
      fill: "rgb(74, 126, 152)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.567 34.372c-28.692 61.724-23.266 100.422 16.275 116.094 59.313 23.508 200.347 32.911 259.299 83.906 58.95 50.994 238.697 11.572 269.438-75.95C1310.32 70.9 1365.669-64 1073.808-64c-194.576 0-307.654 32.79-339.24 98.372h-.001z",
    fill: "#FFFA72",
    fillRule: "nonzero",
    transform: "translate(-750, 25) scale(1.75, 1.75) skewX(12.5) ",
    style: {
      position: "relative",
      zIndex: 7,
      fill: "rgb(70, 141, 161)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.567 34.372c-28.692 61.724-23.266 100.422 16.275 116.094 59.313 23.508 200.347 32.911 259.299 83.906 58.95 50.994 238.697 11.572 269.438-75.95C1310.32 70.9 1365.669-64 1073.808-64c-194.576 0-307.654 32.79-339.24 98.372h-.001z",
    fill: "#FFFA72",
    fillRule: "nonzero",
    transform: "translate(-600, 20) scale(1.6, 1.6) skewX(10) ",
    style: {
      position: "relative",
      zIndex: 8,
      fill: "rgb(65, 157, 170)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.567 34.372c-28.692 61.724-23.266 100.422 16.275 116.094 59.313 23.508 200.347 32.911 259.299 83.906 58.95 50.994 238.697 11.572 269.438-75.95C1310.32 70.9 1365.669-64 1073.808-64c-194.576 0-307.654 32.79-339.24 98.372h-.001z",
    fill: "#FFFA72",
    fillRule: "nonzero",
    transform: "translate(-450, 15) scale(1.45, 1.45) skewX(7.5) ",
    style: {
      position: "relative",
      zIndex: 9,
      fill: "rgb(61, 173, 180)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.567 34.372c-28.692 61.724-23.266 100.422 16.275 116.094 59.313 23.508 200.347 32.911 259.299 83.906 58.95 50.994 238.697 11.572 269.438-75.95C1310.32 70.9 1365.669-64 1073.808-64c-194.576 0-307.654 32.79-339.24 98.372h-.001z",
    fill: "#FFFA72",
    fillRule: "nonzero",
    transform: "translate(-300, 10) scale(1.3, 1.3) skewX(5) ",
    style: {
      position: "relative",
      zIndex: 10,
      fill: "rgb(56, 188, 189)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.567 34.372c-28.692 61.724-23.266 100.422 16.275 116.094 59.313 23.508 200.347 32.911 259.299 83.906 58.95 50.994 238.697 11.572 269.438-75.95C1310.32 70.9 1365.669-64 1073.808-64c-194.576 0-307.654 32.79-339.24 98.372h-.001z",
    fill: "#FFFA72",
    fillRule: "nonzero",
    transform: "translate(-150, 5) scale(1.15, 1.15) skewX(2.5) ",
    style: {
      position: "relative",
      zIndex: 11,
      fill: "rgb(52, 204, 198)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardBg);
export default __webpack_public_path__ + "static/media/DashboardBG.4fc28aafd367ad1c327974ecf8b69065.svg";
export { ForwardRef as ReactComponent };